<script setup lang="ts">
import {Link} from '@inertiajs/vue3';

const props = defineProps({
    href: {
        type: String,
        default: '#',
    },
    label: {
        type: String,
        default: 'Not set',
    },
    external: Boolean,
    white: Boolean,
    remove_width: Boolean,
});

const normal = !props.white;

</script>

<template>
    <component
        :is="external? 'a' : Link"
        class="flex-center relative h-12 rounded-sm uppercase transition duration-300 lg:h-13"
        :class="{
            'border-primary bg-primary text-white ring-primary hover:bg-primary-800 hover:ring-primary-800 focus:ring-primary-600': normal,
            'hover:bg-grey-50 border-primary bg-white text-primary ring-primary hover:ring-primary-800 focus:ring-primary-600': white,
            'w-60': !remove_width,
        }"
        :href="href"
    >
        {{ label }}
    </component>
</template>
